import { usePostCommunicationContext } from 'app/modules/posts/modules/post/components/postCommunication/PostCommunicationProvider';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import CommentsApi from 'app/modules/comments/api';

export function useCommentsSummary() {
  const { postId, activeContent } = usePostCommunicationContext();

  return useQuery(
    queryKey.postCommentsSummary({
      postId,
      thread: activeContent,
    }),
    () => CommentsApi.commentsSummary(postId),
  );
}
